module.exports = __webpack_public_path__ + "img/0-02-0a-1b046cd5e0e2e1ccdf5672449892d13903acf99e2881fc30ae59d3931f0e7d64_c5fbd4f7.81fd439a.jpg";